import React, { useEffect, useMemo, useState } from "react";
import styles from "../../styles/patient-page-modules/Charts.module.css";
import CarePlanNew from "./careplanNew";
// import CarePlan from "./careplan";
import { useSearchParams } from "react-router-dom";
import Readings from "./readings";
import {
  Panel,
  TabList,
  TabPanels,
  TabTrigger,
  Tabs,
} from "../../components/ui/tab";
import useRoles from "../../hooks/useRoles";
const Charts = ({
  patientId,
  isOpen,
  onClose,
  handlePatientType,
  setChatBotType,
  isCcmChatStarted,
  onStartTocaCopilot,
  patientType,
  // May 2026 redesign: allow the page-level RPM/CCM toggle to drive this
  // component without showing the internal TabList. When `hideToggle` is
  // true, the TabList renders nothing; when `forcedTab` is provided it
  // overrides the internal `activeSection` state.
  hideToggle = false,
  forcedTab,
  compactToolbar = false,
}) => {
  const { position } = useRoles();
  const dashType = sessionStorage.getItem("_dash");
  const isNurseDashboard = dashType === "nurse";

  const [activeSection, setActiveSection] = useState(() => {
    const savedTab = sessionStorage.getItem("tab-selected");
    return savedTab || "RPM";
  });

  const [queryParams] = useSearchParams();
  const CCM = Boolean(parseInt(queryParams.get("CCM")));
  const RPM = Boolean(parseInt(queryParams.get("RPM")));

  const tabs = useMemo(() => {
    if (isNurseDashboard) {
      return CCM ? ["CCM"] : [];
    }

    const tabs = [];
    if (RPM) tabs.push("RPM");
    if (CCM) tabs.push("CCM");

    return tabs.length ? tabs : ["CCM"];
  }, [isNurseDashboard, RPM, CCM]);

  const handleToggle = (section) => {
    handlePatientType(section);
    setActiveSection(section);
    sessionStorage.setItem("tab-selected", section);
  };

  useEffect(() => {
    if (activeSection === "RPM") {
      setChatBotType("RPM");
    } else if (activeSection === "CCM") {
      setChatBotType("CCM");
    }
  }, [activeSection]);

  const fallbackTab = tabs[0] || "CCM";
  const currentTab = tabs.includes(activeSection) ? activeSection : fallbackTab;

  useEffect(() => {
    if (currentTab !== activeSection) {
      handlePatientType(currentTab);
      setActiveSection(currentTab);
      sessionStorage.setItem("tab-selected", currentTab);
    }
  }, [currentTab, activeSection, handlePatientType]);

  // Sync internal active section to an externally-controlled tab (page-level
  // RPM/CCM toggle). Only runs when `forcedTab` prop changes.
  useEffect(() => {
    if (forcedTab && forcedTab !== activeSection && tabs.includes(forcedTab)) {
      setActiveSection(forcedTab);
      sessionStorage.setItem("tab-selected", forcedTab);
      handlePatientType(forcedTab);
    }
  }, [forcedTab]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* Toggler Buttons (hidden when an external page-level toggle drives state) */}

      <Tabs value={currentTab}>
        {!hideToggle && (
          <TabList>
            {tabs.map((tab) => (
              <TabTrigger
                key={tab}
                value={tab}
                handleClick={() => handleToggle(tab)}
              >
                {tab}
              </TabTrigger>
            ))}
          </TabList>
        )}
        <TabPanels>

          <Panel value="RPM">{RPM &&
            <Readings
              patientId={patientId}
              isSectionOpen={isOpen}
              onSectionClose={onClose}
              compactToolbar={compactToolbar}
              programLabel={currentTab}
            />
          }</Panel>

          <Panel value="CCM">
            {CCM &&
              <CarePlanNew
                isSectionOpen={isOpen}
                onSectionClose={onClose}
                isCcmChatStarted={isCcmChatStarted}
                onStartTocaCopilot={onStartTocaCopilot}
              />}
            {/* {CCM && <CarePlan isCcmChatStarted={isCcmChatStarted} />} */}
          </Panel>

        </TabPanels>
      </Tabs>
    </>
  );
};

export default Charts;
